import React, { useMemo } from 'react';
import { CalendarIcon, MapPinIcon, UsersIcon, HeartIcon, CheckCircleIcon, StarIcon, ZapIcon, ThumbsUpIcon } from 'lucide-react';
interface EventCardProps {
  title: string;
  date: string;
  location: string;
  imageUrl: string;
  friendsGoing?: number;
  friendsInterested?: number;
  category: string;
  recommendationReason?: string | string[];
}
export const EventCard = ({
  title,
  date,
  location,
  imageUrl,
  friendsGoing = 0,
  friendsInterested = 0,
  category,
  recommendationReason
}: EventCardProps) => {
  // Random icon selection for recommendation reasons
  const getRandomRecommendationIcon = () => {
    const icons = [<CheckCircleIcon size={16} className="mr-2 text-green-400" data-id="element-47" />, <HeartIcon size={16} className="mr-2 text-pink-500" data-id="element-48" />, <StarIcon size={16} className="mr-2 text-yellow-400" data-id="element-49" />, <ZapIcon size={16} className="mr-2 text-purple-400" data-id="element-50" />, <ThumbsUpIcon size={16} className="mr-2 text-blue-400" data-id="element-51" />];
    return icons[Math.floor(Math.random() * icons.length)];
  };
  // Handle the recommendation reason which can be string or string[]
  const displayRecommendation = useMemo(() => {
    if (!recommendationReason) return null;
    // If it's an array, randomly select one item
    if (Array.isArray(recommendationReason)) {
      if (recommendationReason.length === 0) return null;
      return recommendationReason[Math.floor(Math.random() * recommendationReason.length)];
    }
    // Otherwise return the string as is
    return recommendationReason;
  }, [recommendationReason]);
  return <div className="bg-[#2C2F33] rounded-xl overflow-hidden hover:shadow-lg transition-shadow" data-id="element-52">
      <div className="relative h-48" data-id="element-53">
        <img src={imageUrl} alt={title} className="w-full h-full object-cover" data-id="element-54" />
        <div className="absolute top-3 left-3" data-id="element-55">
          <span className="bg-[#007BFF] text-white px-3 py-1 rounded-full text-sm font-medium" data-id="element-56">
            {category}
          </span>
        </div>
      </div>
      <div className="p-4" data-id="element-57">
        <h3 className="text-[#F5F5F7] font-bold text-xl mb-2" data-id="element-58">{title}</h3>
        <div className="flex items-center text-gray-400 mb-2" data-id="element-59">
          <CalendarIcon size={16} className="mr-2" data-id="element-60" />
          <span data-id="element-61">{date}</span>
        </div>
        <div className="flex items-center text-gray-400 mb-3" data-id="element-62">
          <MapPinIcon size={16} className="mr-2" data-id="element-63" />
          <span data-id="element-64">{location}</span>
        </div>
        {displayRecommendation && <div className="bg-gradient-to-r from-[#1A2030] to-[#2A3040] p-2 rounded-lg mb-4 flex items-center text-[#00CCFF]" data-id="element-65">
            {getRandomRecommendationIcon()}
            <span className="text-sm font-medium" data-id="element-66">{displayRecommendation}</span>
          </div>}
        {(friendsGoing > 0 || friendsInterested > 0) && <div className="flex flex-col space-y-1 text-gray-300 mb-4" data-id="element-67">
            {friendsGoing > 0 && <div className="flex items-center" data-id="element-68">
                <UsersIcon size={16} className="mr-2 text-[#007BFF]" data-id="element-69" />
                <span data-id="element-70">{friendsGoing} friends going</span>
              </div>}
            {friendsInterested > 0 && <div className="flex items-center" data-id="element-71">
                <UsersIcon size={16} className="mr-2 text-[#00AAFF]" data-id="element-72" />
                <span data-id="element-73">{friendsInterested} friends interested</span>
              </div>}
          </div>}
        <div className="flex space-x-2 mb-2" data-id="element-74">
          <button className="bg-gradient-to-r from-sky-500 to-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors flex-1" data-id="element-75">
            Get Tickets
          </button>
          <button className="border border-[#007BFF] text-[#007BFF] px-4 py-2 rounded-lg font-medium hover:bg-[#1A1A1D] transition-colors" data-id="element-76">
            I'm Interested
          </button>
        </div>
        <button className="w-full bg-[#2A3040] hover:bg-[#343B4D] text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center justify-center" data-id="element-77">
          <UsersIcon size={16} className="mr-2 text-[#00AAFF]" data-id="element-78" />
          Plan with Friends
        </button>
      </div>
    </div>;
};